import axiosClient from './axiosClient';

export const adminDashboardService = {
    getStats: async () => {
        const resp = await axiosClient.get('/admin/dashboard/stats');
        return resp.data;
    },
    getCharts: async (period) => {
        const resp = await axiosClient.get('/admin/dashboard/charts', {
            params: { period }
        });
        return resp.data;
    },
    getRecentOrders: async () => {
        const resp = await axiosClient.get('/admin/dashboard/recent-orders');
        return resp.data;
    },
    getTopVendors: async () => {
        const resp = await axiosClient.get('/admin/dashboard/top-vendors');
        return resp.data;
    },
    getVendorApplications: async () => {
        const resp = await axiosClient.get('/admin/dashboard/vendor-applications');
        return resp.data;
    },
    getSalesReport: async () => {
        const resp = await axiosClient.get('/dashboard/admin/sales');
        return resp.data.data;
    }
};
